module.exports = __webpack_public_path__ + "static/img/supplyAndDemand.ea7029b2.svg";